import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Button from "../general/Button";
import Cookies from "js-cookie";
import AuthServices from "../../services/Auth.services";
import ToastService from "../../services/Toast.Service";
import DataBlockLabel from "../account/DataBlockLabel";
import TwoFactorInputModal from "../general/TwoFactorInputModal";
import Link from "next/link";

export default function LoginForm({ creds }) {
  const router = useRouter();
  const [auth, setAuth] = useState();
  const [userInfo, setUserInfo] = useState();
  const [passwordType, setPasswordType] = useState("password");
  const [passwordIcon, setPasswordIcon] = useState(
    "/assets/icon/show-icon.png"
  );

  // const [remembered, setRemembered] = useState();
  const [rememberPassword, setRememberPassword] = useState(false);

  //   Inloggen
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [succes, setSucces] = useState();
  const [show2FAPopup, setShow2FAPopup] = useState(false);
  const [userId, setUserId] = useState(null);

  const zetStateUitOfzo = () => {
    setShow2FAPopup(false);
  };

  const getUserOfzo = (data) => {
    const toast = ToastService.loadToast("Vul uw code in");
    data.profileId = userId;

    const promise = fetch(
      process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/two-factor-login",
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => response)
      .then(async (data) => {
        return {
          ok: data.ok,
          data: await data.json(),
          status: data.status,
        };
      })
      .then((data) => {
        if (!data.ok) {
          throw data;
        }

        ToastService.successToast("Ingelogd!", toast);

        var hour = 1 / 24;

        Cookies.set("auth", data.data.token, {
          expires: hour,
          path: "/",
        });

        setAuth(AuthServices.loggedIn());
        setUserInfo(AuthServices.getUserData());
        router.push("/dashboard");
      });

    ToastService.promiseToast(promise, "Inloggen!", "Ingelogd!");
  };

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
    setPasswordIcon(
      passwordType === "password"
        ? "/assets/icon/hide-icon.png"
        : "/assets/icon/show-icon.png"
    );
  };

  const onSubmit = (data) => {
    const toast = ToastService.loadToast("Laden...");

    fetch(process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/login", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response)
      .then(async (response) => {
        return {
          ok: response.ok,
          data: await response.json(),
          status: response.status,
        };
      })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        if (response.data?.usingTwoFactor) {
          setUserId(response.data.profile);
          setShow2FAPopup(true);
        } else {
          ToastService.successToast("Ingelogd!", toast);

          var hour = 1 / 24;

          Cookies.set("auth", response.data.token, {
            expires: hour,
            path: "/",
          });

          if (rememberPassword === true) {
            AuthServices.rememberLogin(data);
          }

          setAuth(AuthServices.loggedIn());
          setUserInfo(AuthServices.getUserData());
          router.push("/dashboard");
        }
      })
      .catch((err) => {
        err.status === 418 ? router.push("/pending") : "";
        ToastService.errorToast(err?.data?.message, toast);
      });
  };

  const handleRememberPassword = (event) => {
    setRememberPassword(event.target.checked ? true : false);
  };

  if (!auth) {
    return (
      <>
        <TwoFactorInputModal
          isopen={show2FAPopup}
          customFn={zetStateUitOfzo}
          getUser={getUserOfzo}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <DataBlockLabel text="Jouw gegevens" />
          <div className="mt-2 bg-white px-4 py-5 rounded-tl-lg rounded-br-lg space-y-6">
            <InputWrapper title="E-mail*">
              <input
                type="email"
                {...register("username", {
                  required: true,
                  pattern: /^\S+@\S+$/i,
                })}
                placeholder="E-mail"
                defaultValue={creds?.username}
                id="username"
                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                  errors.username || errors.username?.type == "not_equal"
                    ? "border-red-500"
                    : "border-white"
                }`}
              />
              {errors.username?.type === "required" && (
                <div className="group shrink-0 absolute right-2">
                  <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                    Dit veld is vereist
                  </span>
                </div>
              )}
            </InputWrapper>
            <InputWrapper title="Wachtwoord*">
              <div className={"flex flex-col relative"}>
                <input
                  type={passwordType}
                  {...register("password", {
                    required: true,
                  })}
                  defaultValue={creds?.password}
                  placeholder="Wachtwoord"
                  id="password"
                  className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                    errors.password || errors.password?.type == "not_equal"
                      ? "border-red-500"
                      : "border-white"
                  }`}
                />
                <img
                  className="absolute top-1/2 transform -translate-y-1/2 right-2 w-4 h-4 object-contain cursor-pointer"
                  src={passwordIcon}
                  alt="chevron right"
                  onClick={togglePassword}
                />
              </div>
              {errors.password?.type === "required" && (
                <div className="group shrink-0 absolute right-2">
                  <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                    Dit veld is vereist
                  </span>
                </div>
              )}
            </InputWrapper>

            <div className="flex items-center">
              <div className="w-1/3 shrink-0">
                <p className="text-sm lg:text-base text-olaf-green-500">
                  <strong>Wachtwoord onthouden</strong>
                </p>
              </div>
              <div className="ml-4 w-2/3 flex items-center">
                <div className="w-full flex">
                  <input onChange={handleRememberPassword} type={"checkbox"} />
                  <label className={"ml-2"}>30 dagen geldig</label>
                </div>
              </div>
            </div>
            <div className={"mt-2"}>
              <Link legacyBehavior href={"/wachtwoord-vergeten"}>
                <a className={"underline text-xs"} rel="noopener">
                  Wachtwoord vergeten
                </a>
              </Link>
            </div>
          </div>
          <div className="flex space-x-2 mt-4">
            <Button
              text="Account aanmaken"
              url="/registreren"
              style="secondary"
            />
            <button
              type="submit"
              className="cursor-pointer w-full h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] bg-olaf-green-500 text-white text-sm font-bold hover:bg-white hover:text-olaf-green-500 transition duration-200 ease-in-out"
            >
              Inloggen
            </button>
          </div>
        </form>
      </>
    );
  }
  return (
    <div>
      <p>Hallo, {userInfo.username}</p>
      <button onClick={() => AuthServices.logout()}>Uitloggen</button>
    </div>
  );
}

function InputWrapper({ title, children }) {
  return (
    <div className="flex items-center">
      <div className="w-1/3 shrink-0">
        <p className="text-sm lg:text-base text-olaf-green-500">
          <strong>{title}</strong>
        </p>
      </div>
      <div className="ml-4 w-2/3 flex items-center">
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
}
